export default __webpack_public_path__ + "static/media/tru-logo.d79129a5.svg";